/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSettingsUnitCommand } from '../../models/create-settings-unit-command';
import { CreateSettingsUnitCommandResult } from '../../models/create-settings-unit-command-result';

export interface ApiSettingsUnitsCreateSettingsUnitPost$Params {
      body?: CreateSettingsUnitCommand
}

export function apiSettingsUnitsCreateSettingsUnitPost(http: HttpClient, rootUrl: string, params?: ApiSettingsUnitsCreateSettingsUnitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateSettingsUnitCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSettingsUnitsCreateSettingsUnitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateSettingsUnitCommandResult>;
    })
  );
}

apiSettingsUnitsCreateSettingsUnitPost.PATH = '/api/SettingsUnits/CreateSettingsUnit';
